import { render, staticRenderFns } from "./ConsultInfo.vue?vue&type=template&id=689a82bc&scoped=true&"
import script from "./ConsultInfo.vue?vue&type=script&lang=js&"
export * from "./ConsultInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConsultInfo.vue?vue&type=style&index=0&id=689a82bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a82bc",
  null
  
)

export default component.exports